import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

const styles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
}
export const AppLoader = () => {
  return (
    <Box sx={styles}>
      <CircularProgress />
    </Box>
  )
}
